module.exports = __webpack_public_path__ + "static/media/wavm8s-2018-end-of-year-edition.927d30b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-2018-end-of-year-edition.mp3
// module id = GD59
// module chunks = 0